//ALL PRACTITIONERS
export const REQUEST_PRACTITIONERS = "list-practitioners";
export const SEARCH_REQUEST_PRACTITIONERS = "search-practitioners";

//DETAILS ONE PRACTITIONER
export const REQUEST_PROFIL_PRACTITIONER = "profil-practitioner";
export const REQUEST_PROFIL_PLATFORM_PRACTITIONER = "profil-platform-practitioner";

export const REQUEST_TRANSACTIONS_PRACTITIONER = "list-transaction-practitioner";
export const SEARCH_TRANSACTION_PRACTITIONERS = "search-transaction-practitioner";

//GLOBAL ACTION
export const LOADED_PRACTITIONERS = "loaded-practitioners";

export const REQUEST_FILES_PRACTITIONER = "files-practitioner";
export const ADD_FILE_PRACTITIONER = "add-file-practitioner";

export const LOADED_FILES_PRACTITIONER = "loaded-files-practitioner";
export const LOADED_SIGNATURE_PRACTITIONER = "loaded-signature-practitioner";
export const LOADED_CNI_PRACTITIONER = "loaded-cni-practitioner";

export const UPDATE_PRACTITIONER = "update-practitioner";
export const UPDATED_PRACTITIONER = "updated-practitioner";

export const SYNCHRONISE_PRACTITIONER = "synchronise-practitioner";
export const SYNCHRONISED_PRACTITIONER = "synchronised-practitioner";

//ALL PRACTITIONERS
export function requestPractitioners() {
    return {
        type: REQUEST_PRACTITIONERS,
    };
}

export function searchPractitioners(payload) {
    return {
        type: SEARCH_REQUEST_PRACTITIONERS,
        data: payload
    };
}

//DETAILS ONE PRACTITIONER
export function requestProfilPractitioner(payload) {
    return {
        type: REQUEST_PROFIL_PRACTITIONER,
        payload: payload
    };
}

export function requestProfilPlatformPractitioner(payload) {
    return {
        type: REQUEST_PROFIL_PLATFORM_PRACTITIONER,
        payload: payload
    };
}

export function requestTransactionsPractitioner(payload) {
    return {
        type: REQUEST_TRANSACTIONS_PRACTITIONER,
        payload: payload
    };
}

export function searchTransactionsPractitioners(payload) {
    return {
        type: SEARCH_TRANSACTION_PRACTITIONERS,
        payload: payload
    };
}

export function requestFilesPractitioner(payload) {
    return {
        type: REQUEST_FILES_PRACTITIONER,
        payload: payload
    };
}

export function addFilePractitioner(payload) {
    return {
        type: ADD_FILE_PRACTITIONER,
        data: payload
    }
}


export function loadedPractitioners(payload) {
    return {
        type: LOADED_PRACTITIONERS,
        payload: payload
    };
}


export function loadedFilesPractitioner(payload) {
    return {
        type: LOADED_FILES_PRACTITIONER,
        payload: payload
    };
}


export function loadedSignaturePractitioner(payload) {
    return {
        type: LOADED_SIGNATURE_PRACTITIONER,
        payload: payload
    };
}


export function loadedCNIPractitioner(payload) {
    return {
        type: LOADED_CNI_PRACTITIONER,
        payload: payload
    };
}

export function updatePractitionerData(payload) {
    return {
        type: UPDATE_PRACTITIONER,
        id: payload.id,
        data: payload
    };
}
export function updatedPractitioner() {
    return {
        type: UPDATED_PRACTITIONER
    };
}

export function synchronisePlatform(payload) {
    return {
        type: SYNCHRONISE_PRACTITIONER,
        id: payload.id
    };
}
export function synchronisedPractitioner() {
    return {
        type: SYNCHRONISED_PRACTITIONER
    };
}


// WEBPACK FOOTER //
// ./src/actions/practitioners.action.js